import { render, staticRenderFns } from "./SpecsLogger.vue?vue&type=template&id=5f4f17eb"
import script from "./SpecsLogger.vue?vue&type=script&lang=ts"
export * from "./SpecsLogger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports